import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { upperCase } from 'lodash';

@Component({
  selector: 'app-lrc-benef-renderer',
  templateUrl: './lrc-benef-renderer.component.html',
  styleUrls: ['./lrc-benef-renderer.component.scss'],
})
export class LrcBenefRendererComponent implements ICellRendererAngularComp {
  value: string | undefined;
  beneficiary: string | undefined;
  params: HttpParams | undefined;
  data: any;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.value = params.value;
    this.data = params.data;

    if (this.data?.type === 'CASH_OUT' || this.data?.type === 'PAYMENT') {
      this.beneficiary = upperCase(
        this.data?.transaction_object?.app_user?.first_name +
          ' ' +
          this.data?.transaction_object?.app_user?.last_name
      );
    } else if (this.data?.type === 'REMITTANCE') {
      this.beneficiary = upperCase(
        this.data?.transaction_object?.receiver_name
      );
    } else {
      this.beneficiary = upperCase(
        this.data?.transaction_object?.receiver?.app_user
          ? this.data?.transaction_object?.receiver?.app_user?.first_name_en +
              ' ' +
              this.data?.transaction_object?.receiver?.app_user?.last_name_en
          : this.data?.transaction_object?.receiver?.first_name +
              ' ' +
              this.data?.transaction_object?.receiver?.last_name
      );
    }

    const httpParams = (params as any)?.httpParams;
    if (httpParams) {
      this.params = httpParams;
    }
  }

  refresh(params: ICellRendererParams) {
    this.value = params.value;
    this.data = params.data;

    const httpParams = (params as any)?.httpParams;
    if (httpParams) {
      this.params = httpParams;
    }
    return true;
  }
}
